module.exports = __webpack_public_path__ + "static/media/controllerLogo.d929e18e.png";